// extracted by mini-css-extract-plugin
module.exports = {"editPlayer":"ProfileEdit_editPlayer__2TO1Y"};